import { Link } from 'react-router-dom'
import { CheckOutlined } from '../../../components/icons'
import { formatDate } from '../../workspaces/format'
import type { UploadSessionSummary } from '../types'

export interface ConfirmedSessionRowProps {
  readonly session: UploadSessionSummary
}

/**
 * "Recently confirmed" row (UID-140 S5, `Fictiv Platform.dc.html:2497-
 * 2503`): a check-circle chip, name + part-count/confirmed-date meta, and a
 * "View in library →" link. Routes to the real, already-shipped
 * `/parts` (Parts library) route — not an invented library screen.
 */
export function ConfirmedSessionRow({ session }: ConfirmedSessionRowProps) {
  return (
    <Link to="/parts" className="uploads-confirmed-row">
      <span className="uploads-confirmed-icon" aria-hidden="true">
        <CheckOutlined />
      </span>
      <span className="uploads-confirmed-info">
        <span className="uploads-confirmed-name">{session.name}</span>
        <span className="caption-text">
          {session.partCount != null ? `${session.partCount} parts · ` : ''}
          confirmed {formatDate(session.createdAt)}
        </span>
      </span>
      <span className="uploads-confirmed-link">View in library →</span>
    </Link>
  )
}
